var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { http, delay, HttpResponse } from "msw";
import { accountSummaryV2Url } from "../api/endpoints.js";
import accountSummaryV2QueryMock, { accountSummaryPayInFourMock, accountSummaryWaivedInterestMock } from "./accountSummaryV2QueryMock.js";
const getLineOfBusiness = (type) => {
  switch (type) {
    case "BUSINESS_RETAIL_CARD":
    case "PRIVATE_LABEL":
      return "RETAIL_CARD";
    case "LIMITED_USE_DUAL_CARD":
    case "DUAL_CARD":
    case "INSTALLMENT_LOAN":
      return "PAYMENT_SOLUTIONS_CARECREDIT";
    case "INSTALLMENT_LOAN_PAY_IN_FOUR":
    case "INSTALLMENT_LOAN_MONTHLY":
    default:
      return "SETPAY";
  }
};
const accountSummaryV2GetHandler = ({ hostUrl = void 0, delayMs = 0 }, accountTypeMapping) => {
  const url = hostUrl ? new URL(accountSummaryV2Url, hostUrl).href : accountSummaryV2Url;
  return http.get(url, (_0) => __async(void 0, [_0], function* ({ request }) {
    var _a, _b;
    const { searchParams } = new URL(request.url);
    const accountId = (_a = searchParams.get("cipher.accountId")) != null ? _a : "";
    const accountType = (_b = accountTypeMapping[accountId]) != null ? _b : "DUAL_CARD";
    const lineOfBusiness = getLineOfBusiness(accountType);
    let responseData;
    if (accountType === "INSTALLMENT_LOAN_PAY_IN_FOUR") {
      responseData = accountSummaryPayInFourMock();
    }
    if (accountType === "INSTALLMENT_LOAN_MONTHLY") {
      responseData = accountSummaryWaivedInterestMock();
    } else {
      responseData = accountSummaryV2QueryMock();
    }
    responseData.product.type = accountType;
    responseData.product.lineOfBusiness = lineOfBusiness;
    yield delay(delayMs);
    return HttpResponse.json(responseData);
  }));
};
export { accountSummaryV2GetHandler };
//# sourceMappingURL=accountSummaryV2Query.msw.js.map
